import React from 'react';

// Components
import WpProgressBar from '../WpProgressBar';
import WpSplitProgressBar from '../WpSplitProgressBar';

const ProgressDocs = () => {
  const ProgressBar = () => {
    return (
      <>
        <h4 className="mb-4">Small Progress Bar</h4>
        <h5 className="mb-4">
          {' '}
          Success bar with 10%
          <WpProgressBar color="success" size="sm" percent={10}></WpProgressBar>
        </h5>
        <h5 className="mb-4">
          {' '}
          Primary bar with 50%
          <WpProgressBar color="primary" size="sm" percent={50}></WpProgressBar>
        </h5>

        <h4 className="mb-4">Medium Progress Bar</h4>
        <h5 className="mb-4">
          {' '}
          Success bar with 10%
          <WpProgressBar color="success" size="md" percent={10}></WpProgressBar>
        </h5>
        <h5 className="mb-5">
          {' '}
          Primary bar with 50%
          <WpProgressBar color="primary" size="md" percent={50}></WpProgressBar>
        </h5>
      </>
    );
  };

  const SplitProgressBar = () => {
    return (
      <>
        <h4 className="mb-4">Small Split Progress Bar</h4>
        <h5 className="mb-4">
          {' '}
          Split Progress bar step 2 of 3
          <WpSplitProgressBar
            size="sm"
            currentNumberStep={2}
            steps={[{ stepNumber: 1 }, { stepNumber: 2 }, { stepNumber: 3 }]}
          ></WpSplitProgressBar>
        </h5>
        <h5 className="mb-4">
          {' '}
          Split Progress bar step 3 of 3
          <WpSplitProgressBar
            size="sm"
            currentNumberStep={3}
            steps={[{ stepNumber: 1 }, { stepNumber: 2 }, { stepNumber: 3 }]}
          ></WpSplitProgressBar>
        </h5>

        <h4 className="mb-4">Medium Split Progress Bar</h4>
        <h5 className="mb-4">
          {' '}
          Split Progress bar step 2 of 3
          <WpSplitProgressBar
            size="md"
            currentNumberStep={2}
            steps={[{ stepNumber: 1 }, { stepNumber: 2 }, { stepNumber: 3 }]}
          ></WpSplitProgressBar>
        </h5>
        <h5 className="mb-4">
          {' '}
          Split Progress bar step 3 of 3
          <WpSplitProgressBar
            size="md"
            currentNumberStep={3}
            steps={[{ stepNumber: 1 }, { stepNumber: 2 }, { stepNumber: 3 }]}
          ></WpSplitProgressBar>
        </h5>
      </>
    );
  };
  return (
    <>
      <ProgressBar></ProgressBar>
      <SplitProgressBar></SplitProgressBar>
    </>
  );
};

export default ProgressDocs;
